import React from "react";
import {
  Button,
  Card,
  CardBody,
  Container,
  Row,
  Col,
} from "reactstrap";
import { Link } from "react-router-dom";

import DemoNavbar from "components/Navbars/DemoNavbar.js";
import SimpleFooter from "components/Footers/SimpleFooter.js";
import { setPageMeta } from "utils/seo.js";

class DataConsulting extends React.Component {
  componentDidMount() {
    setPageMeta({
      title: "Data Consulting",
      description:
        "Cloud data architecture, warehousing on Snowflake and Databricks, Power BI analytics, machine learning, and custom applications, delivered end to end by Chisp.",
      path: "/consulting",
    });
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    this.refs.main.scrollTop = 0;
  }

  render() {
    return (
      <>
        <DemoNavbar />
        <main ref="main">
          <div className="position-relative">
            <section className="section section-lg section-shaped pb-250">
              <div className="shape shape-style-1 shape-chisp-consulting">
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
              </div>
              <Container className="py-lg-md d-flex">
                <div className="col px-0">
                  <Row>
                    <Col lg="10" className="mx-auto text-center">
                      <h1 className="display-3 text-white">
                        Data Consulting{" "}
                        <span>Capabilities</span>
                      </h1>
                      <p className="lead text-white">
                        Cloud data architecture, warehousing, analytics, and custom applications.
                        Our consulting team builds and modernizes the data platforms organizations
                        run on &mdash; from raw ingestion through to the dashboards your teams make
                        decisions with.
                      </p>
                    </Col>
                  </Row>
                </div>
              </Container>
            </section>
          </div>

          <section className="section section-lg pt-lg-0 mt--200">
            <Container>
              <Row className="justify-content-center">
                <Col lg="12">
                  <Row className="row-grid">
                    <Col lg="4">
                      <Card className="shadow border-0 h-100">
                        <CardBody className="py-5">
                          <div className="icon icon-shape icon-shape-primary rounded-circle mb-4">
                            <i className="fa fa-cloud" />
                          </div>
                          <h5 className="text-primary">Cloud &amp; Data Infrastructure</h5>
                          <p className="description mt-3">
                            Using Amazon Web Services, we design and operate the intricate data
                            systems your business depends on, built to expand as you grow.
                          </p>
                          <ul className="list-unstyled mt-3">
                            <li className="py-1">
                              <i className="fa fa-check text-success mr-2" />
                              Secure storage with S3 and managed databases
                            </li>
                            <li className="py-1">
                              <i className="fa fa-check text-success mr-2" />
                              Serverless APIs built on Lambda
                            </li>
                            <li className="py-1">
                              <i className="fa fa-check text-success mr-2" />
                              Cost optimized to your use case
                            </li>
                            <li className="py-1">
                              <i className="fa fa-check text-success mr-2" />
                              Easily expandable backend
                            </li>
                          </ul>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col lg="4">
                      <Card className="shadow border-0 h-100">
                        <CardBody className="py-5">
                          <div className="icon icon-shape icon-shape-info rounded-circle mb-4">
                            <i className="fa fa-database" />
                          </div>
                          <h5 className="text-info">Data Warehousing &amp; Analytics</h5>
                          <p className="description mt-3">
                            We build modern data analytics solutions on Snowflake and Databricks,
                            giving you one trusted place for your data and the compute to work it.
                          </p>
                          <ul className="list-unstyled mt-3">
                            <li className="py-1">
                              <i className="fa fa-check text-success mr-2" />
                              Centralized storage and secure data sharing
                            </li>
                            <li className="py-1">
                              <i className="fa fa-check text-success mr-2" />
                              BI-ready tables for reports and dashboards
                            </li>
                            <li className="py-1">
                              <i className="fa fa-check text-success mr-2" />
                              Large-scale processing on Databricks
                            </li>
                            <li className="py-1">
                              <i className="fa fa-check text-success mr-2" />
                              Demand-based pricing, cost efficient
                            </li>
                          </ul>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col lg="4">
                      <Card className="shadow border-0 h-100">
                        <CardBody className="py-5">
                          <div className="icon icon-shape icon-shape-success rounded-circle mb-4">
                            <i className="fa fa-tachometer" />
                          </div>
                          <h5 className="text-success">Dashboards &amp; Reporting</h5>
                          <p className="description mt-3">
                            Interactive Power BI dashboards wired directly to your warehouse, so
                            the numbers your teams see are the numbers of record.
                          </p>
                          <ul className="list-unstyled mt-3">
                            <li className="py-1">
                              <i className="fa fa-check text-success mr-2" />
                              Clear, visually pleasing data visualizations
                            </li>
                            <li className="py-1">
                              <i className="fa fa-check text-success mr-2" />
                              Direct connections to data warehouses
                            </li>
                            <li className="py-1">
                              <i className="fa fa-check text-success mr-2" />
                              Real-time KPI and metric tracking
                            </li>
                          </ul>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </section>

          <section className="section section-lg bg-gradient-default">
            <Container>
              <Row className="justify-content-center text-center mb-lg">
                <Col lg="8">
                  <h2 className="display-3 text-white">Core Capabilities</h2>
                  <p className="lead text-white">
                    End-to-end coverage of the modern data stack. We can take on a single
                    workstream or own the whole platform.
                  </p>
                </Col>
              </Row>
              <Row className="row-grid">
                <Col lg="4" md="6">
                  <div className="text-center mb-4">
                    <div className="icon icon-lg icon-shape bg-gradient-white shadow rounded-circle text-primary mb-4">
                      <i className="fa fa-sitemap text-primary" />
                    </div>
                    <h5 className="text-white">Cloud Data Architecture</h5>
                    <p className="text-white">
                      Pipelines, storage, and services designed for your workloads and built
                      to scale without a rewrite.
                    </p>
                  </div>
                </Col>
                <Col lg="4" md="6">
                  <div className="text-center mb-4">
                    <div className="icon icon-lg icon-shape bg-gradient-white shadow rounded-circle text-primary mb-4">
                      <i className="fa fa-database text-primary" />
                    </div>
                    <h5 className="text-white">Data Warehousing</h5>
                    <p className="text-white">
                      Snowflake and Databricks implementations that centralize scattered data
                      into one governed source of truth.
                    </p>
                  </div>
                </Col>
                <Col lg="4" md="6">
                  <div className="text-center mb-4">
                    <div className="icon icon-lg icon-shape bg-gradient-white shadow rounded-circle text-primary mb-4">
                      <i className="fa fa-pie-chart text-primary" />
                    </div>
                    <h5 className="text-white">Analytics &amp; Dashboards</h5>
                    <p className="text-white">
                      Power BI and Streamlit front ends that turn warehouse tables into
                      decisions people actually make.
                    </p>
                  </div>
                </Col>
                <Col lg="4" md="6">
                  <div className="text-center mb-4">
                    <div className="icon icon-lg icon-shape bg-gradient-white shadow rounded-circle text-primary mb-4">
                      <i className="fa fa-wifi text-primary" />
                    </div>
                    <h5 className="text-white">IoT &amp; Sensor Data Systems</h5>
                    <p className="text-white">
                      Real-time systems for streaming device and sensor data, drawing on the
                      same engineering behind our own IoT platform.
                    </p>
                  </div>
                </Col>
                <Col lg="4" md="6">
                  <div className="text-center mb-4">
                    <div className="icon icon-lg icon-shape bg-gradient-white shadow rounded-circle text-primary mb-4">
                      <i className="fa fa-eye text-primary" />
                    </div>
                    <h5 className="text-white">Machine Learning &amp; Image Analysis</h5>
                    <p className="text-white">
                      Predictive modeling, image classification and detection, and motion
                      analysis for data that goes beyond spreadsheets.
                    </p>
                  </div>
                </Col>
                <Col lg="4" md="6">
                  <div className="text-center mb-4">
                    <div className="icon icon-lg icon-shape bg-gradient-white shadow rounded-circle text-primary mb-4">
                      <i className="fa fa-cogs text-primary" />
                    </div>
                    <h5 className="text-white">Custom Applications &amp; Tools</h5>
                    <p className="text-white">
                      Internal tools, KPI portals, and role-based analytical apps built around
                      how your teams actually work.
                    </p>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>

          <section className="section bg-white">
            <Container>
              <Row className="row-grid align-items-center">
                <Col md="6">
                  <div className="pr-md-5">
                    <div className="icon icon-lg icon-shape icon-shape-warning shadow rounded-circle mb-4">
                      <i className="ni ni-camera-compact" />
                    </div>
                    <h3>Beyond the Spreadsheet</h3>
                    <p className="lead">
                      Plenty of the most valuable data in an operation never lands in a table.
                      It arrives as images, video, and sensor streams.
                    </p>
                    <p>
                      We build systems that read that data directly: image classification and
                      detection, motion analysis, and AI-powered pattern recognition, running
                      alongside real-time alerting and device management. It is the same
                      capability that powers the Chisp IoT Dashboard, applied to whatever your
                      environment produces.
                    </p>
                  </div>
                </Col>
                <Col md="6">
                  <Card className="shadow border-0">
                    <CardBody className="p-lg-5">
                      <h4 className="mb-3">Applications &amp; Tools We Build</h4>
                      <p className="description">
                        Custom applications tailored to the problem you are actually trying to
                        solve. Examples include:
                      </p>
                      <ul className="list-unstyled mt-4">
                        <li className="py-2">
                          <i className="fa fa-check text-success mr-2" />
                          Dashboards to visualize data
                        </li>
                        <li className="py-2">
                          <i className="fa fa-check text-success mr-2" />
                          Internal analytical tools
                        </li>
                        <li className="py-2">
                          <i className="fa fa-check text-success mr-2" />
                          AI-powered tools
                        </li>
                        <li className="py-2">
                          <i className="fa fa-check text-success mr-2" />
                          KPI tracking portals
                        </li>
                        <li className="py-2">
                          <i className="fa fa-check text-success mr-2" />
                          Role-based analytical apps
                        </li>
                        <li className="py-2">
                          <i className="fa fa-check text-success mr-2" />
                          Data management systems
                        </li>
                      </ul>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </section>

          <section className="section section-lg">
            <Container>
              <Row className="justify-content-center text-center mb-lg">
                <Col lg="8">
                  <h2 className="display-3">Client Examples</h2>
                  <p className="lead text-muted">
                    A sample of the work our consulting team has delivered across healthcare,
                    transit, and public recreation.
                  </p>
                </Col>
              </Row>
              <Row className="row-grid">
                <Col lg="4">
                  <Card className="shadow border-0 h-100">
                    <CardBody className="px-lg-4 py-lg-5">
                      <div className="text-center text-muted mb-4">
                        <i className="fa fa-heartbeat fa-3x" />
                      </div>
                      <h6 className="text-info text-uppercase">Public Healthcare</h6>
                      <h5 className="mt-2">Data Platform Modernization</h5>
                      <p className="description mt-3">
                        We partnered with a public healthcare company to modernize their data
                        infrastructure: refactoring existing ETL pipelines, migrating and
                        centralizing data into a scalable cloud-based platform, and implementing
                        Snowflake as their core data warehouse.
                      </p>
                      <p className="description">
                        On top of it we developed Power BI dashboards and Streamlit applications
                        for real-time analytics and decision support, then provided enablement
                        through training on Snowflake and Databricks so their internal teams
                        could manage and extend the platform.
                      </p>
                    </CardBody>
                  </Card>
                </Col>
                <Col lg="4">
                  <Card className="shadow border-0 h-100">
                    <CardBody className="px-lg-4 py-lg-5">
                      <div className="text-center text-muted mb-4">
                        <i className="fa fa-subway fa-3x" />
                      </div>
                      <h6 className="text-primary text-uppercase">NYCT</h6>
                      <h5 className="mt-2">Remote Monitoring &amp; Asset Tracking</h5>
                      <p className="description mt-3">
                        We developed IoT-enabled remote camera systems to support NYCT track
                        work sites, focused on monitoring PPE compliance to improve job site
                        safety and enhance operational oversight.
                      </p>
                      <p className="description">
                        We also implemented asset tracking capabilities to monitor equipment
                        utilization and location, providing data-driven insights into field
                        operations.
                      </p>
                    </CardBody>
                  </Card>
                </Col>
                <Col lg="4">
                  <Card className="shadow border-0 h-100">
                    <CardBody className="px-lg-4 py-lg-5">
                      <div className="text-center text-muted mb-4">
                        <i className="fa fa-cube fa-3x" />
                      </div>
                      <h6 className="text-success text-uppercase">Parks &amp; Recreation</h6>
                      <h5 className="mt-2">IoT Smart Locker System</h5>
                      <p className="description mt-3">
                        We developed an IoT-enabled smart locker platform that allows users to
                        rent equipment directly from the locker system, use it, and return it
                        when finished, with rental duration tracked automatically and users
                        charged for the time the equipment is checked out.
                      </p>
                      <p className="description">
                        The platform integrates hardware, connectivity, and a cloud-based
                        management system that gives operators real-time usage data, inventory
                        tracking, and operational insights.
                      </p>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </section>

          <section className="section section-lg bg-gradient-default">
            <Container>
              <Row className="text-center justify-content-center">
                <Col lg="10">
                  <h2 className="display-3 text-white">Why Chisp?</h2>
                  <p className="lead text-white">
                    We are a group of passionate and experienced engineers, designers, and
                    innovators. With a versatile range of skills, we can provide end-to-end
                    solutions for all of your systems&rsquo; needs.
                  </p>
                </Col>
              </Row>
              <Row className="row-grid mt-5">
                <Col lg="4">
                  <div className="text-center">
                    <div className="icon icon-lg icon-shape bg-gradient-white shadow rounded-circle text-primary mb-4">
                      <i className="fa fa-users text-primary" />
                    </div>
                    <h4 className="text-white mt-3">End-to-End Team</h4>
                    <p className="text-white mt-3">
                      Architecture, engineering, analytics, and application development from
                      one team, with no handoffs between vendors.
                    </p>
                  </div>
                </Col>
                <Col lg="4">
                  <div className="text-center">
                    <div className="icon icon-lg icon-shape bg-gradient-white shadow rounded-circle text-primary mb-4">
                      <i className="fa fa-plug text-primary" />
                    </div>
                    <h4 className="text-white mt-3">Hardware to Dashboard</h4>
                    <p className="text-white mt-3">
                      Because we build our own IoT products, we can follow a signal from the
                      sensor all the way to the executive report.
                    </p>
                  </div>
                </Col>
                <Col lg="4">
                  <div className="text-center">
                    <div className="icon icon-lg icon-shape bg-gradient-white shadow rounded-circle text-primary mb-4">
                      <i className="fa fa-graduation-cap text-primary" />
                    </div>
                    <h4 className="text-white mt-3">Enablement Included</h4>
                    <p className="text-white mt-3">
                      We train your team on the platforms we implement, so you are never
                      dependent on us to keep moving.
                    </p>
                  </div>
                </Col>
              </Row>
              <Row className="justify-content-center mt-5">
                <Col lg="8" className="text-center">
                  <Button
                    className="btn-round"
                    color="white"
                    size="lg"
                    to="/contact"
                    tag={Link}
                  >
                    Talk to our consulting team
                  </Button>
                </Col>
              </Row>
            </Container>
          </section>
        </main>
        <SimpleFooter />
      </>
    );
  }
}

export default DataConsulting;
